import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router, useCapacitorBackButton } from './router';
import { useAppInit } from './hooks/useAppInit';
import { DirectionProvider } from './contexts/DirectionContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { configureScrollRestoration } from './utils/scrollUtils';
import './i18n/config';

/**
 * AppProviders component to handle all global providers
 * Following SRP by separating provider management from the main App component
 */
const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <BrandingProvider>
      <ThemeProvider>
        <DirectionProvider>
          {children}
        </DirectionProvider>
      </ThemeProvider>
    </BrandingProvider>
  );
};

/**
 * Main App component
 * Follows SRP by focusing only on app initialization and core routing
 */
const App: React.FC = () => {
  useAppInit();
  
  // Configure scroll restoration behavior once at app initialization
  useEffect(() => {
    configureScrollRestoration();
  }, []);
  
  // Handle back button navigation on mobile devices
  useCapacitorBackButton();
  
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
};

export default App; 